
<div style="margin:150px">

  <!-- <div class="container">

  <h1>Angular 8 Bootstrap Collapse Example - ItSolutionStuff.com</h1>

  <p>
    <a type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
      [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
      Collapse Toggle
    </a>
  </p>
  <div id="collapseExample" [ngbCollapse]="isCollapsed">
    <div class="card">
      <div class="card-body">
        You can collapse this card by clicking Toggle Button. This is example from ItSolutionStuff.com.
      </div>
    </div>
  </div>

</div> -->


<div class="container">
  <div class="row">

    <div class="col-sm" style="max-width: 43%">

      <img [src]="imageUrl" alt="Image">
      <!-- <img src="../../../assets/images/Job-profile-main.jpg" > -->
    </div>
    <div class="col-sm">

      <p #headertextid>
      {{headertext}}</p>
      <button (click)=showpopupvideo()>More -></button>
    </div>
    <div class="row">
      <div class="col-sm">
        <div class="d-flex" style="float:right">


          <div class="btn-group dropdown">
            <img src="./../../assets/images/Help.jpg" style="width:35px;" alt="..." href="#" role="button"
              id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >


              <div class="dropdown-menu" aria-labelledby="dropdownMenuLink" style="position:absolute;">
                <a class="dropdown-item" href="./../../assets/Templates/NLP-User Guide.docx">User Guide</a>
                <!-- <a class="dropdown-item" href="#">Watch Video</a>
                <a class="dropdown-item" href="#">FAQ's</a> -->
                <a class="dropdown-item" href="#" (click)=showpopup()>Contact Support</a>
                <a class="dropdown-item" href="#" (click)=showpopupAdmin()>Admin Panel</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="rowmain" >
      <div>
        <button (click)="singleprofile()" [ngClass]="{cssClass1: activeClass, cssClass2: !activeClass}">Single Job
        Profile Search </button>
      </div>
      <div>
        <button (click)="multipleprofile()" [ngClass]="{cssClass2: activeClass, cssClass1: !activeClass}">Multiple Job
        Profile Search</button>
      </div>
    </div>






    <form [formGroup]="form" (ngSubmit)="submitForm()">
      @if (single) {
        <div class="row">
          @if (aqchecked) {
            <div class="col-sm"  >
              <div class="form-group">
                <label for="exampleFormControlInput2" class="existing-label-class">
                  Job Family Group Name
                  <span class="help-icon" tabindex="0">?</span>
                  <span class="help-tooltip">
                    Job Family Groups are used only to prioritize output results. Jobs that are part of the selected Job Family Group(s) are ranked higher, while all jobs remain part of the matching process.
                  </span>
                </label>
                <ng-multiselect-dropdown style="width:100px"
                  [placeholder]="'Please Select'"
                  [settings]="dropdownSettings"
                  [data]="jobfamilygroup"
                  formControlName="job_family_group"
                  (onSelect)="onItemSelect($event)"
                  (onSelectAll)="onSelectAll($event)"
                  (onDeSelect)="onItemDeSelect($event)"
                  (onDeSelectAll)="onUnSelectAll()"
                  >
                </ng-multiselect-dropdown>
                <!-- <select class="custom-select" (change)="onSelectChange($event)" style="width: 100% !important;">
                <option value=''>Please select</option>
                <option *ngFor="let fam of jobfamilygroup" value={{fam}}>
                  {{fam}}
                </option>
              </select> -->
            </div>
          </div>
        }
      </div>
    }

    @if (single) {
      <div class="row">
        <div class="col-sm">
          <div class="form-group">
            <label for="exampleFormControlInput1">Job Title (use non abbreviation text for better result)</label>
            <input type="text" autofocus class="form-control" formControlName="job_title" id="exampleFormControlInput1"
              placeholder="Enter job title">
              @if (check_jobtitle) {
                <div
                  style="color:red">
                  Please provide a job title
                </div>
              }
            </div>
            <div class="form-group">
              <label for="exampleFormControlTextarea1">Job Description</label>
              <textarea class="form-control" formControlName="job_family" id="exampleFormControlTextarea1"
              rows="3"></textarea>
              @if (check_jobdesc) {
                <div
                  style="color:red">
                  Please provide a job description
                </div>
              }
            </div>
          </div>
        </div>
      }



      <!-- <div class="row" style="margin-left:0px" *ngIf="this.form.get('FileSearch')?.value"> -->
      @if (multiple) {
        <div>
          <div class="form-group">
            <a style="padding-left:400px;" [attr.href]="downloadhref" download class="a-download">Click
              here to download the template file
            </a>
            <!-- <label *ngIf="!aqchecked" style="padding-left:400px;"  >Uploaded file must not have more than 3  job titles</label> -->
            <div class="box" style="padding-left:460px!important">
              <div class="row">
                <div class="col-sm" style="max-width: 200px!important;">
                  <label for="fup"><img src="./../../assets/images/File.jpg"></label>
                  <br>
                    <input id="fup" class="box_file" type="file" formControlName="job_profile_match_file"
                      (click)="resetFile($event)" (change)="uploadFile($event)" >
                    </div>
                    <!-- <div class="col-sm">
                    <label>
                      <ul>
                        <li>
                          Maximum allowed file size 2 mb
                        </li>
                        <li>
                          File type is restricted to .csv
                        </li>
                        <li>
                          Uploaded file must not have more than 3 unique job titles
                        </li>
                      </ul>
                    </label>
                  </div> -->
                </div>
                <br>
                  <label>File type is restricted to .xlsx</label>
                  <br>
                    <!-- <label>Uploaded file must not have more than 3  job titles</label> -->
                  </div>
                  <div style="padding-left:400px!important">
                  </div>
                </div>
                <!-- <div
                *ngIf="form.get('job_profile_match_file')?.invalid && (form.get('job_profile_match_file')?.dirty || form.get('job_profile_match_file')?.touched)"
                style="color:red">
                Please upload a valid csv file.
              </div> -->
              @if (fileLimitexceeded) {
                <div style="color:red">
                  Uploaded file has records which exceeds the allowed limit! Please edit the file and try again!
                </div>
              }
            </div>
          }



          <div class="row" style="margin-top:10px">
            <div class="col-6 col-md-4"></div>
            <div class="col-6 col-md-5" style="padding-left: 97px;">
              <div class="form-group">
                <button class="btn btn-primary btn-block btn-lg" [disabled]="fileLimitexceeded">Submit</button>
              </div>
            </div>
            @if (showRefreshbtn) {
              <div class="row" style="margin:10px;margin-top:15px">
                <div class="col-12">
                  <div class="alert alert-danger" role="alert">
                    {{errorMsg}}
                  </div>
                </div>
              </div>
            }

            <div [style.display]="ShowLoader">
              @if (aqchecked) {
                <div class="loading">
                  @if (pageload) {
                    <span> Please allow a min while the application loads </span>
                  }
                  @if (submitclicked) {
                    <span> Calculating results... </span>
                  }
                </div>
              }
              <div class="background-image"></div>

              <div id="loader">


              </div>

              @if (!aqchecked) {
                <div class="loading">Results will be available in 5 mins...</div>
              }
            </div>
            <!-- <div class="col-2" *ngIf="showRefreshbtn">
            <div class="form-group">
              <button type="button" (click)="refreshForm()" class="btn btn-primary btn-block btn-lg">Refresh</button>
            </div>
          </div> -->

        </div>


      </form>
      @if (showResults) {
        <div class="row" >
          <label style="margin:18px 10px 0px 0px;font-family:'Graphik';">Job Family</label>
          @for (filter of filters; track filter) {
            <mat-form-field appearance="fill">
              <!-- <mat-label>Job Family</mat-label> -->
              <mat-select [(value)]="filter.defaultValue" (selectionChange)="applyFilter($event, filter)">
                @for (op of filter.options; track op) {
                  <mat-option [value]="op">
                    {{ op }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <br />
          <!-- <div class="row" style="margin-bottom:10px;float:right" [hidden]="!showResults"> -->
          <!-- <div class="col-sm-12">
          <h4 style="color:#007bff;font-weight:450">Job Profile Matching Results
          </h4>
          <div class="wrapper">
            <div class="row">
              <div class="col-3">-->
                <!--Old hai ye commented
                <mat-form-field *ngFor="let filter of filterSelectObj" style="margin-left: 15px;">
                  <mat-label>Filter {{filter.name}}</mat-label>
                  <select matNativeControl name="{{filter.columnProp}}" [(ngModel)]="filter.modelValue"
                    (change)="filterChange(filter,$event)">
                    <option value="">-- Select {{filter.name}} --</option>
                    <option [value]="item" *ngFor="let item of filter.options">{{item}}</option>
                  </select>
                </mat-form-field>
                &nbsp;
                <button mat-flat-button color="warn" (click)="resetFilters()">Reset</button> -->
                <!-- <ng-multiselect-dropdown style="background-color: gainsboro;" [placeholder]="'Select'"
                [settings]="dropdownSettings" [data]="uniqueJobFamilyList" [(ngModel)]="selectedJobTitle"
                (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)"
                (onSelectAll)="onSelectAll($event)"
                (onDeSelectAll)="onDeSelectAll($event)">
              </ng-multiselect-dropdown>
              yahan tak-->
            <!-- </div>
          </div> -->
          <!-- <div class="col-10">
          <div *ngIf="jobTitle!='' && jobDescription!=''">Showing for Job Title :<strong>'{{jobTitle}}'</strong>  and Job Description: <strong>'{{jobDescription}}'</strong>
        </div>
      </div> -->
      <div style="float:right;margin:4px">
        <button  (click)="export()"  style="margin:0px 0px 0px 8px !important;height: 39px !important;padding:8px 25px;font-size:13px!important;">Download All</button>
        <!-- <input type="image" src="./../../assets/images/Download.jpg" title="Download" name="submit" height="35px"
        alt="submit" (click)="export()" />
      </div> -->
      <!-- <button class="btn btn-primary btn-block float-right" style="font-size:14px" (click)="exporter.exportTable('xlsx',{fileName:'jobprofilematching_data',sheet:jobTitle.substring(0,31)})">
      Download Results
      <span class="material-icons">
        arrow_circle_down
      </span>
    </button> -->
  </div>
  <div class="row">
    <!-- <mat-form-field appearance="fill" *ngFor="let filter of filters">
    <mat-label>{{ filter.name }}</mat-label>
    <mat-select [(value)]="filter.defaultValue" (selectionChange)="applyFilter($event, filter)">
      <mat-option *ngFor="let op of filter.options" [value]="op">
        {{ op }}
      </mat-option>
    </mat-select>
  </mat-form-field> -->
  <br />
  <div [hidden]="!showResults">
    <table mat-table matTableExporter [dataSource]="dataSource"   #exporter="matTableExporter"
      id="maintable">
      @for (column of displayedColumns; track column) {
        <ng-container [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
          <td mat-cell *matCellDef="let profile">{{ profile[column] }}</td>
        </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let profilerow; columns: displayedColumns"></tr>
    </table>
    <table>
      <tr *matNoDataRow>
        <td style="text-align: center;" [attr.colspan]="displayedColumns.length">
          No Records Found!
        </td>
      </tr>
    </table>
    <!-- <mat-paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons></mat-paginator> -->
  </div>
  <!-- <mat-table matTableExporter #exporter="matTableExporter" [dataSource]="dataSource" matSort class="mat-elevation-z8">
  <ng-container matColumnDef="jobTitle">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Job Title </th>
    <td mat-cell *matCellDef="let element"> {{element.jobTitle}} </td>
  </ng-container>
  <ng-container matColumnDef="jobDescription">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Job Description </th>
    <td mat-cell *matCellDef="let element"> {{element.jobDescription}} </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</mat-table>
<table>
  <tr *ngIf="!dataSource">
    <td style="text-align: center;" [attr.colspan]="displayedColumns.length">
      No Records Found!
    </td>
  </tr>
</table>
<mat-paginator [hidden]="!dataSource" [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons></mat-paginator> -->
</div>
</div>
}
</div>







<!-- <div class="row" style="margin:15px" *ngIf="showRefreshbtn" class="alert">
{{errorMsg}}
</div> -->


